import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";

const MetaDetails = ({ helpData, setHelpData, originalHelpData, handleHelpSubmit }) => {
    const [hasChanges, setHasChanges] = useState(false);
    const [iconFile, setIconFile] = useState(null);

    const extractSrc = (input) => {
        if (typeof input !== "string") return "";
        const match = input.match(/src=["'](.*?)["']/);
        return match?.[1] || input.trim();
    };

    const safeHelpData = {
        title: helpData?.title || "",
        description: helpData?.description || "",
        keywords: helpData?.keywords || "",
        author: helpData?.author || "",
        icon: helpData?.icon || "",
        scripts: Array.isArray(helpData?.scripts)
            ? helpData.scripts
            : typeof helpData?.scripts === "string"
                ? (() => {
                    try {
                        return JSON.parse(helpData.scripts);
                    } catch {
                        return [];
                    }
                })()
                : []
    };








    useEffect(() => {
        if (!originalHelpData) {
            setHasChanges(true); // Always show save on first render when there's no existing meta
            return;
        }
        const baseData = { ...safeHelpData, icon: null };
        const original = { ...originalHelpData, icon: null };
        const changed =
            JSON.stringify(baseData) !== JSON.stringify(original) || iconFile !== null;
        setHasChanges(changed);
    }, [safeHelpData, originalHelpData, iconFile]);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setHelpData((prev) => ({ ...prev, [name]: value }));
    };

    const handleScriptChange = (index, value) => {
        const updatedScripts = [...safeHelpData.scripts];
        updatedScripts[index] = value;
        setHelpData((prev) => ({ ...prev, scripts: updatedScripts }));
    };

    const addScriptField = () => {
        setHelpData((prev) => ({
            ...prev,
            scripts: [...(prev.scripts || []), ""]
        }));
    };

    const removeScriptField = (index) => {
        const updatedScripts = [...safeHelpData.scripts];
        updatedScripts.splice(index, 1);
        setHelpData((prev) => ({ ...prev, scripts: updatedScripts }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) setIconFile(file);
    };


    // const onSubmit = () => {
    //   handleHelpSubmit({ ...safeHelpData }, iconFile); 
    //     setIconFile(null);
    // };

    const onSubmit = () => {
        const finalData = {
            ...safeHelpData,
            scripts: Array.isArray(safeHelpData.scripts)
                ? safeHelpData.scripts
                : typeof safeHelpData.scripts === "string"
                    ? (() => {
                        try {
                            return JSON.parse(safeHelpData.scripts);
                        } catch {
                            return [];
                        }
                    })()
                    : []
        };

        handleHelpSubmit(finalData, iconFile);
        setIconFile(null);
    };


    return (
        <div className="profile-form-container">
            {/* Meta Title */}
            <div className="profile-form-group">
                <label className="profile-form-label">Meta Title</label>
                <input
                    type="text"
                    name="title"
                    value={safeHelpData.title}
                    onChange={handleChange}
                    className="profile-form-input"
                    placeholder="Enter meta title"
                />
            </div>

            {/* Meta Description */}
            <div className="profile-form-group">
                <label className="profile-form-label">Meta Description</label>
                <textarea
                    name="description"
                    value={safeHelpData.description}
                    onChange={handleChange}
                    className="profile-form-input"
                    rows={2}
                    placeholder="Enter meta description"
                />
            </div>

            {/* Meta Keywords */}
            <div className="profile-form-group">
                <label className="profile-form-label">Meta Keywords</label>
                <input
                    type="text"
                    name="keywords"
                    value={safeHelpData.keywords}
                    onChange={handleChange}
                    className="profile-form-input"
                    placeholder="Enter keywords"
                />
            </div>

            {/* Meta Author */}
            <div className="profile-form-group">
                <label className="profile-form-label">Meta Author</label>
                <input
                    type="text"
                    name="author"
                    value={safeHelpData.author}
                    onChange={handleChange}
                    className="profile-form-input"
                    placeholder="Enter author"
                />
            </div>

            {/* Favicon Upload */}
            <div className="profile-form-group">
                <label className="profile-form-label">Favicon Icon</label>
                <input type="file" accept="image/*" onChange={handleFileChange} />
                {safeHelpData.icon && !iconFile && (
                    <img
                        src={`${API_BASE_URL}/Images/Meta/${safeHelpData.icon}`}
                        alt="Favicon"
                        style={{ maxWidth: "40px", marginTop: "8px" }}
                    />
                )}
                {iconFile && (
                    <p style={{ fontSize: "12px", color: "green" }}>{iconFile.name} selected</p>
                )}
            </div>

            {/* Multiple Script Tags */}
            <div className="profile-form-group">
                <label className="profile-form-label">Script Tags</label>
                {safeHelpData.scripts?.map((script, index) => (
                    <div key={index} style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                        <textarea
                            value={script}
                            onChange={(e) => handleScriptChange(index, e.target.value)}
                            className="profile-form-input"
                            rows={2}
                            placeholder={`Script ${index + 1}`}
                            style={{ flex: 1 }}
                        />
                        <p
                            type="button"
                            onClick={() => removeScriptField(index)}
                        //   className="profile-remove-btn"
                        //   style={{ background: "red", color: "#fff", border: "none", padding: "4px 8px" }}
                        >
                            <i class="fa-solid fa-xmark"></i>
                        </p>
                    </div>
                ))}
                <button
                    type="button"
                    onClick={addScriptField}
                    className="profile-add-btn"
                    style={{
                        marginTop: "4px",
                        background: "#004080",
                        color: "#fff",
                        padding: "6px 10px",
                        border: "none",
                        borderRadius: "4px"
                    }}
                >
                    + Add Script
                </button>
            </div>

            {/* Multiple Script Tags */}
            {/* <div className="profile-form-group">
                <label className="profile-form-label">Script Tags</label>
                {safeHelpData.scripts?.map((scriptObj, index) => (
                    <div key={index} style={{ display: "flex", gap: "8px", marginBottom: "8px", alignItems: "flex-start" }}>
                 
                        <input
                            type="text"
                            value={scriptObj.title || ""}
                            onChange={(e) => {
                                const updatedScripts = [...safeHelpData.scripts];
                                updatedScripts[index].title = e.target.value;
                                setHelpData((prev) => ({ ...prev, scripts: updatedScripts }));
                            }}
                            className="profile-form-input"
                            placeholder={`Script Title ${index + 1}`}
                            style={{ flex: 1 }}
                        />

                        <textarea
                            value={scriptObj.content || ""}
                            onChange={(e) => {
                                const updatedScripts = [...safeHelpData.scripts];
                                updatedScripts[index].content = e.target.value;
                                setHelpData((prev) => ({ ...prev, scripts: updatedScripts }));
                            }}
                            className="profile-form-input"
                            rows={2}
                            placeholder={`Script Content ${index + 1}`}
                            style={{ flex: 2 }}
                        />

                        <p
                            type="button"
                            onClick={() => {
                                const updatedScripts = [...safeHelpData.scripts];
                                updatedScripts.splice(index, 1);
                                setHelpData((prev) => ({ ...prev, scripts: updatedScripts }));
                            }}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </p>
                    </div>
                ))}

                <button
                    type="button"
                    onClick={() =>
                        setHelpData((prev) => ({
                            ...prev,
                            scripts: [...(prev.scripts || []), { title: "", content: "" }]
                        }))
                    }
                    className="profile-add-btn"
                    style={{
                        marginTop: "4px",
                        background: "#004080",
                        color: "#fff",
                        padding: "6px 10px",
                        border: "none",
                        borderRadius: "4px"
                    }}
                >
                    + Add Script
                </button>
            </div> */}

            {/* Save Button */}
            {hasChanges && (
                <div className="profile-form-group full-span">
                    <button className="profile-save-btn" onClick={onSubmit}>
                        Save Changes
                    </button>
                </div>
            )}
        </div>
    );
};

export default MetaDetails;
